module.exports = __webpack_public_path__ + "media/assets/img/company/logo ministere education-472ca16982c659dcfea6efb09c2c578a.png";